module.exports = __webpack_public_path__ + "img/item-3(1920).79063a5c.jpg";